import * as helper from '../helper';

export function initCookieBanner() {
	const banner = helper.$('#cookiebanner');
	if (banner !== null) {
		const link = banner.querySelector('.cookie-link');
		const close = banner.querySelector('.cookiebanner_close');
		const blocker = helper.$('#blocker');
		const datenschutz = helper.$('#datenschutz');
		const impressum = helper.$('#impressum');

		helper.addClickListener(link, (e: MouseEvent) => {
			e.preventDefault();
			helper.show(blocker);
			helper.show(datenschutz);
			helper.hide(impressum);
		})

		helper.addClickListener(close, (e:MouseEvent) => {
			e.preventDefault();
			helper.setCookie('cookiebanner_seen', '1', 30);
			helper.remove(banner);
		})
	}
}
